import * as Commons from "oc-commons/Commons";
import { BaseInteractionHandler3D } from "oc-interaction/BaseInteractionHandler3D";
import { filter } from "oc-threejs/Scenes";

export class InteractionHandler extends BaseInteractionHandler3D {
  stageEventNames: string[];

  constructor(rootContainer: HTMLElement) {
    super(rootContainer);

    this.forewardEventsToPage();
  }

  forewardEventsToPage() {
    this.stageEventNames.forEach((event) => {
      const method = Commons.getMethodNameForEvent(event);
      STAGE.on(event, () => {
        if (APP.pageInstance?.[method]) {
          APP.pageInstance[method](this.dragObject3d || this.tapObject3d);
        }
      });
    });
  }

  getRestraintsAndSnapsForHandle(): [] {
    return [];
  }

  getInteractingObjects3D() {
    return filter(STAGE.scene, (o) => (o as any).receivesMouseRaycasts);
  }
}
